<template>
  <v-footer fixed height="auto" >
    <v-card class="flex" flat tile >
      <v-card-actions class=" justify-center" style=" background-color: #dbdbdc !important; padding: 11px;
  color: #515a75; box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);">
        &copy;2018 — <strong>ELECTORAL LITERACY CLUB</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    name: "ElcFooter",
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/ElcFooter.vue